/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Read_MoreInputs */

const en_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const es_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer más`)
};

const de_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr lesen`)
};

const zh_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读更多`)
};

const ar_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقرأ المزيد`)
};

const fr_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

const vi_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đọc thêm`)
};

const sw_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soma zaidi`)
};

const th_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อ่านเพิ่มเติม`)
};

const bs_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pročitaj više`)
};

const ja_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと読む`)
};

const ko_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 보기`)
};

const pt_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ler mais`)
};

const it_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi tutto`)
};

const sv_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs mer`)
};

const nl_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees meer`)
};

const da_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs mere`)
};

const nb_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mer`)
};

const fi_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisää`)
};

const pl_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czytaj więcej`)
};

const ru_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читать далее`)
};

const tr_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla oku`)
};

const hi_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const id_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca lagi`)
};

const ms_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca lagi`)
};

const cs_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přečtěte si více`)
};

const el_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαβάστε περισσότερα`)
};

const he_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קראו עוד`)
};

const af_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees meer`)
};

const hu_blog_read_more = /** @type {(inputs: Blog_Read_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bővebben`)
};

/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Blog_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_read_more = /** @type {((inputs?: Blog_Read_MoreInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Read_MoreInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_read_more(inputs)
	if (locale === "de") return de_blog_read_more(inputs)
	if (locale === "zh") return zh_blog_read_more(inputs)
	if (locale === "ar") return ar_blog_read_more(inputs)
	if (locale === "fr") return fr_blog_read_more(inputs)
	if (locale === "vi") return vi_blog_read_more(inputs)
	if (locale === "sw") return sw_blog_read_more(inputs)
	if (locale === "th") return th_blog_read_more(inputs)
	if (locale === "bs") return bs_blog_read_more(inputs)
	if (locale === "ja") return ja_blog_read_more(inputs)
	if (locale === "ko") return ko_blog_read_more(inputs)
	if (locale === "pt") return pt_blog_read_more(inputs)
	if (locale === "it") return it_blog_read_more(inputs)
	if (locale === "sv") return sv_blog_read_more(inputs)
	if (locale === "nl") return nl_blog_read_more(inputs)
	if (locale === "da") return da_blog_read_more(inputs)
	if (locale === "nb") return nb_blog_read_more(inputs)
	if (locale === "fi") return fi_blog_read_more(inputs)
	if (locale === "pl") return pl_blog_read_more(inputs)
	if (locale === "ru") return ru_blog_read_more(inputs)
	if (locale === "tr") return tr_blog_read_more(inputs)
	if (locale === "hi") return hi_blog_read_more(inputs)
	if (locale === "id") return id_blog_read_more(inputs)
	if (locale === "ms") return ms_blog_read_more(inputs)
	if (locale === "cs") return cs_blog_read_more(inputs)
	if (locale === "el") return el_blog_read_more(inputs)
	if (locale === "he") return he_blog_read_more(inputs)
	if (locale === "af") return af_blog_read_more(inputs)
	if (locale === "hu") return hu_blog_read_more(inputs)
	return en_blog_read_more(inputs)
});